module.exports = __webpack_public_path__ + "img/image-2.8746f411.png";